import { CssChainElement } from './CssChainElement.js';

window.customElements.define( 'css-chain', CssChainElement);

export default CssChainElement;
